/* Подтверждение всегда выше всего остального, включая Modal (1000) и
   выпадающие меню: его зовут поверх уже открытого окна — «удалить аккаунт» из
   настроек, «удалить поездку» из формы, — и спор за слой оно обязано выигрывать
   всегда. Иначе вопрос задан, ответить нечем, а экран выглядит зависшим. */
.overlay {
  position: fixed;
  inset: 0;
  z-index: 1200;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--sp-6);
  background: var(--overlay);
}

.panel {
  width: 100%;
  max-width: 420px;
  padding: var(--sp-6);
  background: var(--surface);
  -webkit-backdrop-filter: var(--glass-blur);
  backdrop-filter: var(--glass-blur);
  border-radius: var(--radius-lg);
  box-shadow: var(--glass-rim), var(--shadow-modal);
}

.title {
  margin: 0 0 var(--sp-4) 0;
  font-size: var(--fs-lg);
  font-weight: 600;
}

.message {
  margin: 0 0 var(--sp-6) 0;
  color: var(--text-2);
  font-size: var(--fs-md);
}

.footer {
  display: flex;
  justify-content: flex-end;
  gap: var(--sp-3);
}
